// Copyright (c) 2026 Goffy. This file belongs to Goffy. All Rights Reserved.

import { extractImageVersion } from './imageVersion';
import { getConfiguredAssetBaseUrl } from './mediaUrl';

/**
 * Builds the URL for a tour's image.
 *
 * Always routes through the BFF rather than the stored reference. Stored `imageKey` values
 * are often full S3 URLs (the presign handler returns `GetPublicUrl`), but fetching those
 * directly would require the bucket to be world-readable. The BFF streams the bytes from S3
 * with its own credentials, so the bucket stays private.
 *
 * Returns null when the tour has no image, so callers can fall back to a placeholder.
 */
export const getTourImageUri = (
  apiBaseUrl: string,
  tourId: string | null | undefined,
  imageReference: string | null | undefined,
): string | null => {
  const trimmedTourId = tourId?.trim();
  const trimmedReference = imageReference?.trim();
  if (!trimmedTourId || !trimmedReference) {
    return null;
  }

  // Routes through the CDN when one is configured; CloudFront's origin for this path is
  // the same BFF, so the bucket stays private either way.
  const normalizedBaseUrl = getConfiguredAssetBaseUrl() ?? apiBaseUrl.replace(/\/+$/, '');
  const version = extractImageVersion(trimmedReference);
  return (
    `${normalizedBaseUrl}/api/tours/${encodeURIComponent(trimmedTourId)}/image` +
    `?v=${encodeURIComponent(version)}`
  );
};
